// Backend base URL for non-axios fetch calls (SSE, direct fetch services).
// Keep default aligned with axios baseURL (/api/v1) to avoid endpoint drift.
export const API_URL = (
  process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1'
).replace(/\/+$/, '');
